import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    packing: {
      id: 'pages.packingView.breadcrumbs.packing',
      defaultMessage: 'Packing',
      description: 'Label of the packing breadcrumb on the packing view',
    },
  },
};

export default defineMessages(translations);
